import React from 'react';
import SectionTitle from '@common/typography/SectionTitle';

const baseStyles = 'mb-14 px-3';
const paragraphStyle = 'mb-7 text-15 font-rp-pn-light text-custom-gray leading-6';

type Props = {
  classes?: string;
};

const defaultProps = {
  classes: '',
};

export default function YourPrivacyRightsInfo({ classes }: Props) {
  return (
    <section className={`${classes} ${baseStyles}`}>
      <SectionTitle classes="mb-6">Your Privacy Rights</SectionTitle>
      <p className={paragraphStyle}>
        ResortPass has partnered with Rakuten Advertising for analytics.
      </p>
      <p className={paragraphStyle}>
        Rakuten Advertising may collect personal information when you interact with our digital
        property, including IP addresses, digital identifiers, information about your web browsing
        and app usage and how you interact with our properties and ads for a variety of purposes,
        such as personalization of offers or advertisements, analytics about how you engage with
        websites or ads and other commercial purposes. For more information about the collection,
        use and sale of your personal data and your rights, please use the below links.
      </p>
      <p className={paragraphStyle}>
        Privacy policy :{' '}
        <a
          href="https://rakutenadvertising.com/legal-notices/services-privacy-policy/"
          target="_blank"
          title="Open in a new window"
          rel="noopener noreferrer"
          className="text-custom-link"
        >
          https://rakutenadvertising.com/legal-notices/services-privacy-policy/
        </a>
      </p>
      <p className={paragraphStyle}>
        Your rights :{' '}
        <a
          href="https://rakutenadvertising.com/legal-notices/services-privacy-rights-request-form/"
          target="_blank"
          title="Open in a new window"
          rel="noopener noreferrer"
          className="text-custom-link"
        >
          https://rakutenadvertising.com/legal-notices/services-privacy-rights-request-form/
        </a>
      </p>
    </section>
  );
}

YourPrivacyRightsInfo.defaultProps = defaultProps;
